import '../jquery'

let ready_legacy_variable_visibility;

ready_legacy_variable_visibility = function() {
  let changeFieldVisibility;
  $("body").on("change", ".variable_visibility_field_checkbox", function() {
    let visibility;
    visibility = $(this).is(":checked");
    return changeFieldVisibility(visibility, $(this));
  });
  return changeFieldVisibility = function(visibility, elem) {
    if (visibility) {
      return $(elem).closest('.variable_visibility_input').find('.variable_visibility_field').show();
    } else {
      $(elem).closest('.variable_visibility_input').find('.variable_visibility_field').hide();
      return $(elem).closest('.variable_visibility_input').find('.variable_visibility_field :input').val('');
    }
  };
};

$(document).ready(ready_legacy_variable_visibility);

$(document).on('turbo:load', ready_legacy_variable_visibility);